import React from "react";

// TODO: JukkaS: This component was originally mistakenly taken into use from ComponentLibrary building blocks. Refactor this away from the production code and use CSS only.
export default function Spacer(props: { width?: number; height?: number }) {
    const { width, height } = props;
    return (
        <div
            style={{
                display: "inline-block",
                width: width ?? 10,
                height: height ?? 10,
            }}
        />
    );
}
